var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center flex-shrink-0 transition-all duration-300",
      class: {
        "w-20": !_vm.menu,
        "w-136": _vm.menu
      }
    },
    [
      _c("div", {
        staticClass: "h-full flex-grow flex-shrink",
        on: {
          click: function($event) {
            return _vm.onToggleMenu("")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fixed right-6 z-10 flex flex-col gap-3",
          style: {
            top: "calc(3.75rem + ((100vh - 3.75rem) / 2))",
            transform: "translateY(-50%)"
          }
        },
        _vm._l(_vm.menuOptions, function(item) {
          return _c(
            "div",
            {
              key: item.value,
              staticClass:
                "h-12 w-12 flex items-center justify-center text-center rounded border cursor-pointer",
              class: {
                "border-light-purple bg-light-purple": _vm.menu === item.value,
                "border-slate-400 bg-pure-white": _vm.menu !== item.value
              },
              attrs: { title: item.value },
              on: {
                click: function($event) {
                  return _vm.onToggleMenu(item.value)
                }
              }
            },
            [
              _c("BlIcon", {
                staticClass: "h-8 w-8",
                attrs: {
                  icon: item.icon,
                  color: _vm.menu === item.value ? "white" : "slate-8"
                }
              })
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed z-20 min-w-116 py-px bg-pure-white border border-slate-400 rounded-xl shadow-lg overflow-y-auto",
          class: { "right-20": _vm.menu, "-right-140": !_vm.menu },
          style: {
            top: "calc(3.75rem + ((100vh - 3.75rem) / 2))",
            transform: "translateY(-50%)",
            maxHeight: "calc(100vh - 3.75rem - 3rem)"
          }
        },
        [
          _vm.menu === "Setting"
            ? _c("Setting", {
                staticClass: "w-116",
                on: {
                  close: function($event) {
                    return _vm.onToggleMenu("")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.menu === "Add graph"
            ? _c("AddGraph", {
                staticClass: "w-116",
                attrs: {
                  dragId: _vm.dragId,
                  recommendedTargets: _vm.recommendedTargets
                },
                on: {
                  close: function($event) {
                    return _vm.onToggleMenu("")
                  },
                  "change-focus-id": function($event) {
                    return _vm.$emit("change-focus-id", $event)
                  },
                  "drag-start": function($event) {
                    return _vm.$emit("drag-start", $event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.menu === "View comments"
            ? _c("ViewComments", {
                staticClass: "min-w-116",
                attrs: {
                  settings: _vm.viewCommentsSettings,
                  selectedTargetId: _vm.viewCommentsTargetId
                },
                on: {
                  "change-settings": function($event) {
                    _vm.viewCommentsSettings = $event
                  },
                  "set-target-id": function($event) {
                    _vm.viewCommentsTargetId = $event
                  },
                  close: function($event) {
                    return _vm.onToggleMenu("")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.menu === "View table of contents"
            ? _c("TableOfContents", {
                staticClass: "w-116",
                attrs: { sectionFocusedId: _vm.sectionFocusedId },
                on: {
                  close: function($event) {
                    return _vm.onToggleMenu("")
                  },
                  "change-focus-id": function($event) {
                    return _vm.$emit("change-focus-id", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2eab82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2eab82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ReportHelper.vue
// module id = null
// module chunks = 